import { Col as AntdCol } from 'antd';
import styled from 'styled-components';
export const CardsCol = styled(AntdCol) `
  > * {
    height: 100%;
  }
`;
export const Col = AntdCol;
